import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Icon } from '../../../common/components/Utilities';

function TaskRunner({ csrfToken }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get('/tasks')
      .then((response) => {
        setJobs(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="text-muted">Loading tasks...</div>;
  }

  if (error) {
    return (
      <div className="text-danger">
        Error loading tasks:
        {' '}
        {error}
      </div>
    );
  }

  return (
    <form action="/tasks/run" method="POST">
      <input type="hidden" name="_token" value={csrfToken} />
      <div className="form-group">
        <select className="form-control" name="job">
          {jobs.map((job) => (
            <option key={job.class} value={job.class}>
              {job.label}
            </option>
          ))}
        </select>
      </div>
      <button className="btn btn-block btn-outline-primary mb-2 text-left" type="submit">
        <Icon icon="cogs" variant="fad" append="mr-2" />
        {' '}
        Run Task
      </button>
    </form>
  );
}

TaskRunner.propTypes = {
  csrfToken: PropTypes.string.isRequired,
};

export default TaskRunner;
